import styled, {ThemeProps} from 'styled-components';
import {FlexCentered} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

// TYPES
import {Assign} from 'utility-types';
import {Theme} from '../../../../../../stories/theme/types';
import {textSizes} from '@stencil/build-theme';

export const PersuasionContainer = styled(FlexCentered)(
  props => `
  padding-top:${props.isDwebVideo ? '0' : props.theme.spacing.large};
  justify-content:${props.isDwebVideo ? 'end' : ''}
`,
);

export const PersuasionText = styled.span(
  props => `

  font-size:${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.dark};
  padding-left:${props.theme.spacing.base};
  background: ${props.background ? props.background : props.theme.colors.goWhite.base};
`,
);

export const RatingContainer = styled(FlexCentered)(
  props => `
  flex-direction: column;
  padding:${props.theme.spacing.small} 0;
  background-color: ${props.bgColor};
  border-radius: ${props.theme.misc.borderRadius.large};
  color: ${props.theme.colors.goWhite.base};
  width: 60px;
  height: 42px;
  justify-content: center;
  margin-bottom: 3px;
`,
);

export const ReviewNumber = styled.span(
  (props: Assign<ThemeProps<Theme>, {color?: string}>) => `
    font-size:${props.theme.font.custom(20)};
    font-weight: 600;
`,
);

export const NewWrapper = styled.div`
  width: 9rem;
  border: 1px solid;
  border-radius: 0.8rem;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  color: white;
  background-color: ${props => props.bgColor};
`;

export const New = styled.span`
  font-size: 2rem;
  font-weight: 600;
`;

export const OutOfNumberForReview = styled.span`
  ${textSizes.BaseW3}
  padding-top:0.7rem;
`;

export const ReviewCount = styled.span(
  props => `
  margin-right:0.3rem;
`,
);

// export const TripadvisorImg = styled(Image)(
//   props => `
//   width: 28px;
//   margin: 0 3px;
// `,
// );

export const NumberOfRatingsStyled = styled.span(
  props => `
    color: ${props.theme.colors.goWhite.base};
    padding-top:${props.theme.spacing.small};
    text-align:${props.isDwebVideo ? 'center' : ''}
  `,
);

////////////////////////// TripAdvisorStyles //////////////////////////////

export const OuterWrapper = styled.div(
  props => `
  align-self: center;
`,
);

export const TARatingContainer = styled.div(
  props => `
  display: flex;
  align-items: center;
`,
);

export const TARatingText = styled.p`
  ${textSizes.BaseW3}
  color: ${props => props.theme.colors.downriver.base};
  padding-bottom: ${props => props.theme.spacing.small};
`;

export const TARatingWithCountText = styled.span(
  props => `
  font-size: 12px;
  color: ${props.theme.colors.downriver.medium};
  margin-left: 5px;
    `,
);

export const NewViewMap = styled.div(
  props => `
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  border-radius: 0.8rem;
  cursor: pointer;
  background-image: url('https://gos3.ibcdn.com/mapDweb-1638795011.png');
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 42px;
  margin-bottom: 2px;
`,
);

export const NewMapPin = styled.img(
  props => `
    width: 13.8px;
    height: 25px;
    align-self: center;
    flex-grow: 0;
    margin: 0 41.2px 5px 38px;
    object-fit: contain;
  `,
);

export const NewViewMapCTA = styled.div(
  props => `
  font-size:${props.theme.font.custom(12)};
  color: ${props.theme.colors.goBrandBlue.base};
  border-radius: 0.8rem;
  font-weight: 600;
`,
);

export const FlexItemColumn = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    align-items:end;
  `,
);

export const RatingOuterWrapper = styled.div`
  width: 130px;
  border: 1px solid #e4e4e4;
  border-radius: 0.8rem;
  height: 55px;
  margin-right: 10px;
`;

export const ImageWrapper = styled.div`
  height: 55px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
`;

export const ReviewOuterWrapper = styled.div`
  width: 157px;
  border: 1px solid #e4e4e4;
  border-radius: 0.8rem;
  height: 55px;
`;

export const ReviewInnerWrapper = styled.div`
  height: 55px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
`;

export const RatingWrapper = styled.div`
  border-radius: 0.8rem;
  cursor: pointer;
  background-color: ${props => props.bgColor};
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 42px;
  margin-bottom: 2px;
  color: white;
`;
